import { Field, ErrorMessage } from "formik";
import TextError from "../../../forms/TextError";
import SelectMultipleWithSearch from "../../Admin/Common/SelectMultipleWithSearch";
import { memo, useEffect } from "react";
import { TimePicker } from "antd";
import { handleKeyPress } from "../../../functions/Utils";
import { NUMBER_OF_DAYS, SELECT_DAYS } from "../../../utils/constant";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import SelectItem from "../Common/SelectItem";
dayjs.extend(customParseFormat);
const AddAirlineForm = memo(({ formikData, airPort, airLineList, type }) => {
  const { values } = formikData;
 useEffect(()=>{
  if(values?.arrivalDays!="" && values.departureTime!="" && values.arrivalTime!=""){
    if(values.itinerary.length < 2){
    values.itinerary[0].arrivalDay = values.arrivalDays;
    values.itinerary[0].departure =  values.departureTime;
    values.itinerary[0].arrival=values.arrivalTime;
    }
  }
 },[values])

  return (
    <>
      <div className="airlforminnn">
        <div className="grid 2xl:grid-cols-12 xl:grid-cols-12  lg:grid-cols-12 md:grid-cols-12 sm:grid-cols-12  gap-2 2xl:gap-3 xl:gap-3 lg:gap-3">
          <div className="2xl:col-span-3 xl:col-span-3  lg:col-span-3 md:col-span-4  sm:col-span-6 ">
            <label
              htmlFor={`carrier`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              Carrier
            </label>
            { type === "create" ? (
              <>
                <Field
                  as={SelectMultipleWithSearch}
                  options={airLineList}
                  width={"100%"}
                  id={`carrier`}
                  name={`carrier`}
                  className="leading-4  px-1 py-1 focus:border focus:outline-0  w-[100%] text-sm font-normal border rounded-md text-[#757575]"
                  setFieldValue={formikData.setFieldValue}
                  handlePopulateData={(id) => {
                    const airline = airLineList?.find(
                      (item) => item?.value === id
                    );
                    formikData.setFieldValue(
                      "airlineName",
                      airline?.airlineName
                    );
                  }}
                />
                <ErrorMessage name={`carrier`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values.carrier
                  ? airLineList.find((item) => item.value === values.carrier)
                      ?.label || "N/A"
                  : "N/A"}
              </div>
            )}
          </div>
          <div className="2xl:col-span-3 xl:col-span-3  lg:col-span-3 md:col-span-4  sm:col-span-6 ">
            <label
              htmlFor={`airlineName`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              Airline Name
            </label>
            {type === "create" ? (
              <>
                <Field
                  type="text"
                  id={`airlineName`}
                  name={`airlineName`}
                  className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                  onChange={formikData.handleChange}
                />

                <ErrorMessage name={`airlineName`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.airlineName}
              </div>
            )}
          </div>
          <div className="2xl:col-span-3 xl:col-span-3  lg:col-span-3 md:col-span-4  sm:col-span-6 ">
            <label
              htmlFor={`origin`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              Origin
            </label>
            { type === "create" ? (
              <>
                <Field
                  as={SelectMultipleWithSearch}
                  options={airPort}
                  width={"100%"}
                  id={`origin`}
                  name={`origin`}
                  className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                  handleChange={formikData.handleChange}
                  setFieldValue={formikData.setFieldValue}
                />

                <ErrorMessage name={`origin`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.origin?.split("-")?.[1]?.replace(/[()]/g, "")}
              </div>
            )}
          </div>
          <div className="2xl:col-span-3 xl:col-span-3  lg:col-span-3 md:col-span-6  sm:col-span-6 ">
            <label
              htmlFor={`destination`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              Destination
            </label>
            { type === "create" ? (
              <>
                <Field
                  as={SelectMultipleWithSearch}
                  options={airPort}
                  width={"100%"}
                  id={`destination`}
                  name={`destination`}
                  placeholder="Enter Units"
                  className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                  handleChange={formikData.handleChange}
                  setFieldValue={formikData.setFieldValue}
                />

                <ErrorMessage name={`destination`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.destination?.split("-")?.[1]?.replace(/[()]/g, "")}
              </div>
            )}
          </div>
          <div className="2xl:col-span-2 xl:col-span-2  lg:col-span-2 md:col-span-6  sm:col-span-12 ">
            <label
              htmlFor={`departureTime`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              Departure Time
            </label>
            {type === "edit" || type === "create" ? (
              <>
                <Field id={`departureTime`} name={`departureTime`}>
                  {({ field }) => (
                    // <TimePicker
                    //   value={
                    //     values?.departureTime != null
                    //       ? dayjs(values?.departureTime)
                    //       : null
                    //   }
                    //   format="HH:mm"
                    //   placeholder="Departure time"
                    //   use12Hours={false}
                    //   className="leading-6 px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                    //   onChange={(time, timeString) => {
                    //     formikData.setFieldValue(`departureTime`, time);
                    //   }}
                    // />
                    <TimePicker
                     value={values?.departureTime ? dayjs(values?.departureTime, "HH:mm") : null}
                     format="HH:mm"
                     placeholder="Departure time"
                     use12Hours={false}
                     className="leading-6 px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                     onChange={(time, timeString) => {
                       formikData.setFieldValue(`departureTime`,  time ? time.format("HH:mm") : "");
                     }}
                   />
                  )}
                </Field>

                <ErrorMessage name={`departureTime`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.departureTime}
              </div>
            )}
          </div>
          <div className="2xl:col-span-4 xl:col-span-4  lg:col-span-4 md:col-span-12  sm:col-span-12 DepartureDaysbox ">
            <label
              htmlFor={`departuredays`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              Departure Days
            </label>
            {type === "edit" || type === "create" ? (
              <>
                <Field
                  as={SelectMultipleWithSearch}
                  options={SELECT_DAYS}
                  mode="multiple"
                  width={"100%"}
                  id={`departuredays`}
                  name={`departuredays`}
                  className=" leading-4  px-1 py-1 focus:border focus:outline-0  w-full text-sm font-normal border rounded-md text-[#757575]"
                  handleChange={formikData.handleChange}
                  setFieldValue={formikData.setFieldValue}
                />
                <ErrorMessage name={`departuredays`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.departuredays
                  .map((item) => item.toUpperCase())
                  .join(",")}
              </div>
            )}
          </div>
      
          <div className="2xl:col-span-2 xl:col-span-2  lg:col-span-2 md:col-span-6  sm:col-span-12 ">
            <label
              htmlFor={`departureTime`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
               Arrival Time
            </label>
            {type === "edit" || type === "create" ? (
              <>
                <Field id={`arrivalTime`} name={`arrivalTime`}>
                  {({ field }) => (
                    // <TimePicker
                    //   value={
                    //     values?.departureTime != null
                    //       ? dayjs(values?.departureTime)
                    //       : null
                    //   }
                    //   format="HH:mm"
                    //   placeholder="Departure time"
                    //   use12Hours={false}
                    //   className="leading-6 px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                    //   onChange={(time, timeString) => {
                    //     formikData.setFieldValue(`departureTime`, time);
                    //   }}
                    // />
                    <TimePicker
                     value={values?.arrivalTime ? dayjs(values?.arrivalTime, "HH:mm") : null}
                     format="HH:mm"
                     placeholder="Arrival time"
                     use12Hours={false}
                     className="leading-6 px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                     onChange={(time, timeString) => {
                       formikData.setFieldValue(`arrivalTime`,  time ? time.format("HH:mm") : "");
                     }}
                   />
                  )}
                </Field>

                <ErrorMessage name={`arrivalTime`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.arrivalTime}
              </div>
            )}
          </div>

          <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2   md:col-span-3  col-span-6">
            <label
              htmlFor={`arrivalDays`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              Arrival Days
            </label>
            {type === "edit" || type === "create" ? (
              <>
                <Field
                  as={SelectItem}
                  options={NUMBER_OF_DAYS}
                  width={"100%"}
                  id={`arrivalDays`}
                  name={`arrivalDays`}
                  className="leading-4  px-1 py-1 focus:border focus:outline-0  w-[100%] text-sm font-normal border rounded-md text-[#757575]"
                  setFieldValue={formikData.setFieldValue}
                />
                <ErrorMessage name={`arrivalDays`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.arrivalDays}
              </div>
            )}
          </div>
     
          <div className="2xl:col-span-3 xl:col-span-3  lg:col-span-3 md:col-span-6  sm:col-span-6 ">
            <label
              htmlFor={`lat`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              LAT / Minutes
            </label>
            {type === "edit" || type === "create" ? (
              <>
                <Field
                  type="text"
                  id={`lat`}
                  name={`lat`}
                  className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                  onChange={formikData.handleChange}
                  onKeyPress={handleKeyPress}
                />
                <ErrorMessage name={`lat`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.lat}
              </div>
            )}
          </div>

          <div className="2xl:col-span-3 xl:col-span-3  lg:col-span-3 md:col-span-6  sm:col-span-6 ">
            <label
              htmlFor={`tao`}
              className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
            >
              TAO / Minutes
            </label>
            {type === "edit" || type === "create" ? (
              <>
                <Field
                  type="text"
                  id={`tao`}
                  name={`tao`}
                  className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                  onChange={formikData.handleChange}
                  onKeyPress={handleKeyPress}
                />
                <ErrorMessage name={`tao`} component={TextError} />
              </>
            ) : (
              <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {values?.tao}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default AddAirlineForm;
